// @ts-nocheck
import { useEffect, useState, useCallback } from 'react';

const STORAGE_KEY = 'mov-theme';

const readInitial = () => {
  if (typeof window === 'undefined') return 'light';
  const saved = window.localStorage.getItem(STORAGE_KEY);
  if (saved === 'light' || saved === 'dark') return saved;
  return window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';
};

const apply = (theme) => {
  if (typeof document === 'undefined') return;
  document.documentElement.dataset.theme = theme;
};

// Apply on first import so the initial paint matches the user's preference.
if (typeof window !== 'undefined') apply(readInitial());

/**
 * useTheme — read current theme + a toggle/setTheme pair. Persists to
 * localStorage and reflects on `<html data-theme=…>`.
 */
const useTheme = () => {
  const [theme, setThemeState] = useState(readInitial);

  useEffect(() => {
    apply(theme);
    try { window.localStorage.setItem(STORAGE_KEY, theme); } catch (_e) { /* ignore */ }
  }, [theme]);

  const setTheme = useCallback((next) => setThemeState(next), []);
  const toggle = useCallback(() => setThemeState((t) => (t === 'dark' ? 'light' : 'dark')), []);

  return { theme, setTheme, toggle, isDark: theme === 'dark' };
};

export default useTheme;
